import React from 'react';
import { Link } from 'react-router-dom';
import { LogoFull } from '../../assets/icons';
import { Button } from 'antd';
import { Images } from '../../config/images';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const WentWrong = () => {
  return (
    <div className='errorpage'>
      <div className='errorpage__logo'>
        <LogoFull />
      </div>
      <div className='errorpage__content'>
        <h1 className='errorpage__content__title'>Oh no!</h1>
        <p className='subhead-1 errorpage__content__detail'>Something went wrong</p>
        <p className='errorpage__content__name'>Try refreshing the page or come back later.</p>
        <Button className='errorpage__content__link ant-btn-primary--alt' type='primary'>
          <Link to='/'>Retry</Link>
        </Button>
      </div>
      <div className='errorpage__image'>
        <LazyLoadImage src={Images.error505} alt='Person playing with a puzzle' />
      </div>
    </div>
  );
};

export default WentWrong;
